import React from 'react';
import { CustomSelectComponent, FormCol, FsProps } from 'motion-components';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { DocFilter } from 'shared-pages/common/constants';

export const FieldSelectDocOptions = ({
  label = 'Doc Type',
  name = 'docName',
  defaultValues = {},
  withBlank = true,
  ...rest
}: FsProps & { withBlank?: boolean }) => {
  const { t } = useTranslation();
  const options = [
    ...(!!withBlank ? [{ value: DocFilter.blank, label: t('Λείπει') }] : []),
    { value: DocFilter.onemonth, label: t('Λήγει σε 1 μήνα') },
    { value: DocFilter.expired, label: t('Έχει λήξει') },
  ];
  return (
    <Field
      as={FormCol}
      title={label}
      name={name}
      component={CustomSelectComponent}
      options={options}
    />
  );
};

